import { useRef } from 'react';
import { Badge } from './Badge';
import { Button } from './Button';
import './SimpleCard.scss';
import { useWindowSize } from '../effects/useWindowSize';
import ExpandIcon from '../icons/ExpandIcon';
import { prepareDataAttributesObject } from '../utils/HtmlUtils';
import { formatCurrency } from '../utils/Currency';
import { _t } from '../utils/Lang';

/**
 * 
 * @param {{horizontalWidth:Number|({width:Number}) => Boolean} param0 
 * @returns 
 */
const SimpleCard = ({
    data,
    horizontalWidth,
    bestseller = false,
    hasFullImage = false,
    checked,
    onClick,
    onMoreClick,
    onExpandClick,
    price,
    name,
    image,
    description,
    showChecked = true,
    disabled = false,
    attributesHeader,
    attributes = [] }) => {
    // moreRef
    const moreRef = useRef();
    const expandRef = useRef();

    const size = useWindowSize();

    var classes = ["SimpleCard"];
    if (checked) {
        classes.push("SimpleCard--checked");
    }
    if (showChecked) {
        classes.push("SimpleCard--showChecked");
    }
    if (disabled) {
        classes.push("SimpleCard--disabled");
    }

    if (typeof horizontalWidth === 'function' && horizontalWidth(size)) {
        classes.push("SimpleCard--small");
    } else if (typeof horizontalWidth !== 'function' && size.width < horizontalWidth) {
        classes.push("SimpleCard--small");
    }

    const _onMoreClick = (e) => {
        e.persist();
        console.log({ ref: moreRef.current, target: e.target, e });
        if (e.target === moreRef.current && onMoreClick) {
            onMoreClick();
            // console.log('more click');
            e.preventDefault();
        }
    }
    return (
        <div
            {...prepareDataAttributesObject(data)}
            className={classes.join(" ")}
            disabled={disabled}
            onClick={e => {
                const isButton = e.target.closest('button') !== null;
                if (!isButton) {
                    onClick(e);
                }
            }}>
            <div className="SimpleCard__body">
                <div className="SimpleCard__photo-wrapper">
                    {bestseller ? <div className="SimpleCard__bestseller">Bestseller</div> : null}
                    {image ? <img className="SimpleCard__image" src={image} alt={name} /> : null}
                    {(onExpandClick && hasFullImage) ? <button ref={expandRef} type='button' className="SimpleCard__expand" onClick={onExpandClick}><ExpandIcon /></button> : null}
                </div>
                <div className="SimpleCard__text">

                    <div className="d-flex g-1 w-100 wrap mb-1">
                        <div className="SimpleCard__name">{name}</div>
                        <Badge style={{ whiteSpace: "nowrap" }}>+{formatCurrency(price, { decimal: 0 })}</Badge>
                    </div>
                    <div className="SimpleCard__description">{description}</div>


                    <div className="SimpleCard__header">{attributesHeader}</div>
                    {
                        attributes.length > 0 ? <ul>
                            {
                                attributes.map((item, index) => {
                                    const icon = item?.icon ?? <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.041 8.66709L9.30517 4.40292L8.83333 3.93109L5.041 7.72342L3.141 5.82342L2.66917 6.29525L5.041 8.66709ZM6.00217 12.0619C5.1725 12.0619 4.39244 11.9045 3.662 11.5896C2.93167 11.2747 2.29633 10.8474 1.756 10.3076C1.21567 9.76781 0.787944 9.13303 0.472833 8.40325C0.157611 7.67359 0 6.89387 0 6.06409C0 5.23442 0.157444 4.45436 0.472333 3.72392C0.787222 2.99359 1.21456 2.35825 1.75433 1.81792C2.29411 1.27759 2.92889 0.849865 3.65867 0.534753C4.38833 0.219531 5.16806 0.0619202 5.99783 0.0619202C6.8275 0.0619202 7.60756 0.219365 8.338 0.534254C9.06833 0.849143 9.70367 1.27648 10.244 1.81625C10.7843 2.35603 11.2121 2.99081 11.5272 3.72059C11.8424 4.45025 12 5.22998 12 6.05975C12 6.88942 11.8426 7.66948 11.5277 8.39992C11.2128 9.13025 10.7854 9.76559 10.2457 10.3059C9.70589 10.8463 9.07111 11.274 8.34133 11.5891C7.61167 11.9043 6.83194 12.0619 6.00217 12.0619ZM6 11.3953C7.48889 11.3953 8.75 10.8786 9.78333 9.84525C10.8167 8.81192 11.3333 7.55081 11.3333 6.06192C11.3333 4.57303 10.8167 3.31192 9.78333 2.27859C8.75 1.24525 7.48889 0.728587 6 0.728587C4.51111 0.728587 3.25 1.24525 2.21667 2.27859C1.18333 3.31192 0.666667 4.57303 0.666667 6.06192C0.666667 7.55081 1.18333 8.81192 2.21667 9.84525C3.25 10.8786 4.51111 11.3953 6 11.3953Z" fill="currentColor" />
                                    </svg>
                                    const text = item?.text ?? item;
                                    return <li key={index}>
                                        {icon}

                                        {text}
                                    </li>
                                })
                            }
                        </ul> : null
                    }
                    {
                        typeof onMoreClick === 'function' ? (
                            <div className="d-flex j-start pt-3 pb-2 w-100" style={{ marginTop: 'auto' }}>
                                <Button ref={moreRef} onClick={_onMoreClick} className="primary hollow btn-sm">{_t('learn_more')}</Button>
                            </div>
                        ) : null
                    }

                    {
                        (checked && showChecked) ? (
                            <svg
                                className="SimpleCard__icon"
                                width={18}
                                height={18}
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M-0.000488281 0H17.1424V14.5714C17.1424 16.465 15.6073 18 13.7138 18H-0.000488281V0Z"
                                    fill="black"
                                />
                                <path
                                    d="M4.99951 8.57139L7.99951 11.1428L12.8569 6"
                                    stroke="white"
                                    strokeWidth="0.857143"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                        ) : null
                    }
                </div>
            </div>

        </div>
    );
};

export default SimpleCard;